export default __webpack_public_path__ + "static/media/cancel (2).d1766fed.svg";